import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';

@Component({
  selector: 'app-productfilter',
  templateUrl: './productfilter.component.html',
  styleUrls: ['./productfilter.component.css']
})
export class ProductfilterComponent implements OnInit {

  @Input() doctype: string;
  @Input() mode: string;
  @Input() req:{};
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() msgboxtype: string;
  @Output() emitData = new EventEmitter();
  @Input() displaytxt: string="";

  @Input() productgroupid: number=null;
  @Input() published: string="";
  @Input() inactive: string="";
  @Input() sku: string="";
  @Input() productname: string="";
  @Input() stockstatus: string="";

  @Input() editorValue: string = '';
 
  productgroupColl:any=[];
  publishedColl:any=[];
  inactiveColl:any=[];
  stockColl:any=[]


  constructor(private activeModal: NgbActiveModal,private appService: DhukanDataService,private loginService:LoginDataService) { }

  ngOnInit() {
    this.fnGetPublished();
    this.fnGetInActive();
    this.fngetProductGroup();
    this.fnGetStockStatus()
  }

    
  
  public decline() {
    this.activeModal.close(false);
  }

  public dismiss() {
    this.activeModal.dismiss();
  }


  
fnGetPublished(){
  this.publishedColl=[];
  this.publishedColl.push({name:'PUBLISHED',displayname:'Published'})
  this.publishedColl.push({name:'UNPUBLISHED',displayname:'UnPublished'})
  this.publishedColl.push({name:'ALL',displayname:'All'})
  
}


fnGetInActive(){
  this.inactiveColl=[];
  this.inactiveColl.push({name:'ACTIVE',displayname:'Active'})
  this.inactiveColl.push({ name: 'INACTIVE', displayname: 'Inactive' })  
  this.inactiveColl.push({name:'ALL',displayname:'All'})
  
}
fnGetStockStatus(){
  this.stockColl=[];
  this.stockColl.push({name:'INSTOCK',displayname:'InStock'})
  this.stockColl.push({ name: 'OUTOFSTOCK', displayname: 'OutOfStock' })
  this.stockColl.push({ name: 'ZEROSTOCK', displayname: 'ZeroStock' })
  this.stockColl.push({name:'NEGATIVESTOCK',displayname:'NegativeStock'})
  this.stockColl.push({name:'ALL',displayname:'All'})
  
}



fngetProductGroup() {        
  var data = {
    'productgroupid':0,            
  }
  this.appService.getProductGroup(data)
  .subscribe(
    (res)=>{                  
      this.productgroupColl=res.json().result;     
    },
  (err)=>{              
  })
}




  fnSetFilter(){
    var _data={
      productgroupid:this.productgroupid,
      published:this.published,
      inactive:this.inactive,
      sku:this.sku,
      productname: this.productname,
      stockstatus:this.stockstatus
    }
 
    this.emitData.emit(_data);  
    this.activeModal.close(true); 


  }


}
